import { Component, OnDestroy, OnInit } from '@angular/core';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-select-service',
  templateUrl: './select-service.component.html',
  styleUrls: ['./select-service.component.scss'],
})
export class SelectServiceComponent implements OnInit, OnDestroy {
  model: Captain;
  user: User;

  isInManage: boolean = false;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
  ) {
    this.user = this.userDAO.getCurrentUser();
    this.model = this.user.captain;
    this.route.url.subscribe((url) => {
      console.log(url);
      if (url.length === 1) {
        this.isInManage = true;
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  submit() {
    if (this.isInManage) {
      this.captainDAO.updateUserCaptain(this.model).subscribe(
        () => {
          this.router.navigate(['manage']);
        },
        (err) => console.error(err),
      );
    } else if (this.model.captainForHire) {
      //Normal flow
      this.captainDAO.updateUserCaptain(this.model).subscribe(
        (res) => {
          this.router.navigate(['sign-up/captain-availability']);
        },
        (err) => console.error(err),
      );
    } else if (this.model.anchorAcademy) {
      //Skip to end (aa, aa lb)
      this.captainDAO.updateUserCaptain(this.model).subscribe(
        (res) => {
          this.router.navigate(['sign-up/confirm-email']);
        },
        (err) => console.error(err),
      );
    } else {
      //Skip to boatyard (lb)
      this.user.signupComplete = true;
      this.userDAO.updateUser(this.user).subscribe(
        () => {
          this.captainDAO.updateUserCaptain(this.model).subscribe(() => {
            this.authService
              .getSessionAuthenticatedSubject()
              .next(this.authService.isLoggedIn());
            this.router.navigate(['manage/boatyard']);
          });
        },
        (err) => console.error(err),
      );
    }
  }
}
